import React from 'react';

import { Text, Button, HoverStyles } from '@wix/wix-ui-tpa/cssVars';
import { Pricing } from '../../../../ChallengesPage/Widget/components/Pricing/Pricing';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { dataHooks } from '@wix/data-hooks';
import { FCWithChildren } from '@wix/challenges-web-library';
import { TextAlignment } from '../../../../ChallengesPage/Settings/challengeSettings/challengeSettings.types';
import { useProgramRejoin } from './useProgramRejoin';

import { classes, st } from './ProgramRejoin.st.css';

export interface IProgramRejoinProps {
  className?: string;
  type: 'SidebarGeneral' | 'SidebarOverview';
  prefix?: React.ReactNode;
}

export const programRejoinDataHooks = dataHooks<{
  main;
}>('program-rejoin');

export const ProgramRejoin: FCWithChildren<IProgramRejoinProps> = ({
  className = '',
  type,
  prefix,
}: IProgramRejoinProps) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const {
    isSuspended,
    selectedPaymentOption,
    setSelectedPaymentOption,
    renewParticipation,
  } = useProgramRejoin();

  if (!isSuspended) {
    return null;
  }

  return (
    <section
      className={`${st(classes.root, {
        mobile: isMobile,
        type: type.toLowerCase(),
      })} ${className}`}
      data-hook={programRejoinDataHooks.main()}
    >
      {prefix || null}
      <div className={classes.content}>
        <h4 className={classes.title}>
          {t('live.challenges-page.renew-section.title')}
        </h4>
        <Text tagName="p" className={classes.description}>
          {t('live.challenges-page.renew-section.description')}
        </Text>

        <Pricing
          className={classes.pricing}
          alignment={TextAlignment.Left}
          selectedPaymentOption={selectedPaymentOption}
          onPaymentSelected={setSelectedPaymentOption}
        />

        <Button
          className={classes.button}
          fullWidth={isMobile}
          hoverStyle={HoverStyles.underline}
          onClick={renewParticipation}
        >
          {t('live.challenges-page.renew-section.cta')}
        </Button>
      </div>
    </section>
  );
};
ProgramRejoin.displayName = 'ProgramRejoin';
